import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ITravelPassAccountPayload } from "../../Orchestrator/Types/Interface/ITravelAccounts";

interface IGetTravelAccountsRequest {
  issuer: string;
  travelAccount: string;
}

/**
 * KILL SWITCH — GET /travel-accounts is not called at all (owner decision,
 * 2026-08-25).
 *
 * Every attempt to call it only for genuine ER passes leaked: a Nol day pass
 * answers to PRODUCT_CATEGORY.TRAVEL_PASS in the bookings search, puts a card
 * of type TRAVEL_PASS on the passenger, and is absent from
 * `booking.fulfillments` — so neither the card, the fulfillment, nor the search
 * filter can tell the two apart reliably. The endpoint is off until that is
 * settled with the backend.
 *
 * Consequence, by design: `GetPassBookingObjectAction` gets no account and
 * returns null, so the booked-passes list is empty and the post-payment pass
 * redirect does nothing. Flip this to `true` to restore the old behaviour —
 * nothing else has to change.
 */
const TRAVEL_ACCOUNTS_API_ENABLED = false;

export async function getTravelAccounts(request: IGetTravelAccountsRequest, showLoader?: boolean): Promise<IApiResponse<ITravelPassAccountPayload>> {
  if (!TRAVEL_ACCOUNTS_API_ENABLED) {
    return { status: "ko", code: 0, error: "travel-accounts disabled" };
  }
  const ENDPOINTS = await getEndpoints();
  let endpoint = ENDPOINTS.getTravelAccounts;
  endpoint += `?issuer=${request.issuer}&travelAccount=${request.travelAccount}`;

  return await apiRequest<ITravelPassAccountPayload>(endpoint, 'GET', {}, 'none', undefined, undefined, showLoader);
}
